/* libs/oyan-ui/src/lib/components/cards/components/contact-card/contact-card.component.scss */
.card__contact {
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=contact-card.component.css.map */
